/**
 * Query hooks for fixture-type ↔ shelf-code links.
 */
import { queryOptions, useQuery } from "@tanstack/react-query"
import { bomQueryKeys } from "@/lib/queryKeys"
import { listFixtureTypeShelfCodesFn } from "../server/fixtureTypeShelfCodes"

export function fixtureTypeShelfCodesQueryOptions(configVersionId: string) {
  return queryOptions({
    queryKey: bomQueryKeys.fixtureTypeShelfCodes(configVersionId),
    queryFn: () => listFixtureTypeShelfCodesFn({ data: { configVersionId } }),
    enabled: !!configVersionId,
  })
}

export function useFixtureTypeShelfCodes(configVersionId: string) {
  return useQuery(fixtureTypeShelfCodesQueryOptions(configVersionId))
}
